import React, { useState, useEffect } from "react";
import cry from "./Cry.module.css";
import imgi from "../../img/img16.png";
import imgii from "../../img/img17.png";
import imgiii from "../../img/1mg18.png";
import imgiv from "../../img/img19 (2).png";
import imgv from "../../img/img20.png";
import imgvi from "../../img/img21.png";
import imgvii from "../../img/img13.png";
import { IoMdArrowRoundForward } from "react-icons/io";
import { Link } from "react-router";
import {
  fetchAllPosts,
  subscribeToNewsletter,
  imageUrl,
  convertToDate,
} from "../../Api/PostManApi";

const Crypto = () => {
  const [posts, setpost] = useState([]);
  const [cryptoNews, setCryptoNews] = useState([]);
  const [techNews, setTechNews] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    let timer;
    if (message) {
      timer = setTimeout(() => {
        setMessage("");
      }, 5000); // Message will disappear after 5 seconds
    }
    return () => clearTimeout(timer); // Clean up on unmount
  }, [message]);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const [techResult, cryptoResult, postResult] = await Promise.all([
          fetchAllPosts("Fintech"),
          fetchAllPosts("Cryptocurrency"),
          fetchAllPosts(),
        ]);
        const postArray = Array.isArray(postResult)
          ? postResult
          : postResult?.data?.posts && Array.isArray(postResult.data.posts)
          ? postResult.data.posts
          : [];
        setpost(postArray);
        setCryptoNews(cryptoResult);
        setTechNews(techResult);
      } catch (error) {
        console.error("Fetch error:", error);
        setMessage("Error loading posts");
      }
    };

    fetchPost();
  }, []); // Runs once on mount

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage("");

    // Validate email
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setMessage("Please enter a valid email address.");
      setIsSubmitting(false);
      return;
    }

    try {
      const response = await subscribeToNewsletter(email);
      setMessage(response.message || "Thank you for subscribing!");
      if (response.success) {
        setEmail("");
      }
    } catch (error) {
      setMessage("An error occurred. Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={cry.cry}>
      <div className={cry.container}>
        <div className={cry.content}>
          <div className={cry.flex}>
            <div className={cry.flexI}>
              <div className={cry.flexII}>
                <div className={cry.block}>
                  <button>Cryptocurrency</button>
                  <Link to={`/${cryptoNews?.[0]?.slug}`}>
                    <p>{cryptoNews?.[0]?.title}</p>
                  </Link>

                  <img
                    src={`${imageUrl}/post_images/${cryptoNews?.[0]?.images}`}
                    style={{
                      height: 450,
                      width: "auto",
                    }}
                    alt=""
                  />
                </div>
                <div className={cry.blockI}>
                  <button>Tech news</button>
                  <p>{techNews?.[0]?.title}</p>
                  <img
                    src={`${imageUrl}/post_images/${techNews?.[0]?.images}`}
                    style={{
                      height: 450,
                      width: "auto",
                    }}
                    alt=""
                  />
                </div>
              </div>
              <div className={cry.flexIII}>
                {/* Dynamic crypto news card (originally using [1] index) */}
                {cryptoNews?.slice(0, 4).map((newsItem, index) => (
                  <div key={index} className={cry.card}>
                    <div className={cry.gridI}>
                      <h5>Cryptocurrency</h5>
                      <h5>Business</h5>
                      <h5>Startup</h5>
                    </div>
                    <Link to={`/${newsItem?.slug}`}>
                      <p>{newsItem?.title || "No title available"}</p>
                    </Link>
                    <div className={cry.news}>
                      <h6>{newsItem ? convertToDate(newsItem) : ""}</h6>
                      <h6>·</h6>
                      <h6>{newsItem?.author?.name || "Unknown Author"}</h6>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className={cry.sec}>
              <div className={cry.sec2}>
                <div className={cry.ads}>
                  <h4>ADS POST</h4>
                </div>
                <div className={cry.sign}>
                  <h3>Sign up Newsletter</h3>
                  <p>
                    Get exclusive news directly to your mail, be the first to
                    know what trending and what is happening in the world. Sign
                    up now.
                  </p>
                  <form className={cry.inp} onSubmit={handleSubmit}>
                    <input
                      type="email"
                      value={email}
                      name=""
                      placeholder="Enter your Email"
                      id=""
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    <button type="submit" disabled={isSubmitting}>
                      <IoMdArrowRoundForward className={cry.icon} />
                    </button>
                  </form>
                  {message && (
                    <div
                      className={`${cry.message} ${
                        message.includes("Thank you") ? cry.success : cry.error
                      }`}
                    >
                      {message}
                    </div>
                  )}
                </div>
              </div>
              <div className={cry.secIII}>
                <div className={cry.flexI}>
                  <div className={cry.flexIv}>
                    <div className={cry.block}>
                      <button className={cry.btnI}>Cryptocurrency</button>
                      <Link to={`/${cryptoNews?.[1]?.slug}`}>
                        <p>{cryptoNews?.[1]?.title}</p>
                      </Link>
                      <img
                        src={`${imageUrl}/post_images/${cryptoNews?.[1]?.images}`}
                        height={250}
                        width={"auto"}
                        alt=""
                      />
                    </div>
                    <div className={cry.blockI}>
                      <button className={cry.btnII}>General news</button>
                      <Link to={`/${posts[2]?.slug}`}>
                        <p>{posts[2]?.title}</p>
                      </Link>
                      <img
                        src={`${imageUrl}/post_images/${posts?.[2]?.images}`}
                        alt=""
                      />
                    </div>
                  </div>
                  <div className={cry.flexIII}>
                    {/* Dynamic crypto news card (originally using [1] index) */}
                    {cryptoNews?.slice(1, 5).map((newsItem, index) => (
                      <div key={index} className={cry.card}>
                        <div className={cry.gridI}>
                          <h5>Cryptocurrency</h5>
                          <h5>Business</h5>
                          <h5>Startup</h5>
                        </div>
                        <Link to={`/${newsItem?.slug}`}>
                          <p>{newsItem?.title || "No title available"}</p>
                        </Link>
                        <div className={cry.news}>
                          <h6>{newsItem ? convertToDate(newsItem) : ""}</h6>
                          <h6>·</h6>
                          <h6>{newsItem?.author?.name || "Unknown Author"}</h6>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={cry.contentII}>
            <div className={cry.btn}>
              <button>Trending</button>
            </div>
            <div className={cry.flexVii}>
              {posts?.slice(0, 9).map((item, index) => (
                <div key={index} className={cry.card}>
                  <Link to={`/${item?.slug}`} state={{ source: "A" }}>
                    <img
                      src={`${imageUrl}/post_images/${item.images}`}
                      style={{
                        height: 200,
                        width: "auto",
                      }} // Alternates between images
                      alt={item.title || "News image"}
                    />
                    <p>
                      {item?.title ||
                        (index % 3 === 0
                          ? "Vaccine doesn't cause autism, what does?"
                          : "Transgender tends to protest against trump's officials")}
                    </p>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className={cry.contentb}>
          <h3>ADS POST</h3>
        </div>
      </div>
    </div>
  );
};

export default Crypto;
